<template>
    <div id="deliveryoverviewpage">
        <div class="top-buttons">
            <ui5-button @click="$router.push('/deliverydates')">
                {{ trans('pages.delivery_overview.to_rides') }}
            </ui5-button>
            <ui5-button @click="$router.push('/adddeliveryroute')">
                {{ trans('pages.delivery_overview.add_round') }}
            </ui5-button>
        </div>
        <ui5-table>
            <ui5-table-column slot="columns" :popin-text="trans('pages.delivery_overview.round_id')">
                {{ trans('pages.delivery_overview.round_id') }}
            </ui5-table-column>
            <ui5-table-column slot="columns" :popin-text="trans('pages.delivery_overview.name')">
                {{ trans('pages.delivery_overview.name') }}
            </ui5-table-column>
            <ui5-table-column slot="columns" :popin-text="trans('pages.delivery_overview.description')">
                {{ trans('pages.delivery_overview.description') }}
            </ui5-table-column>
            <ui5-table-column slot="columns" :popin-text="trans('pages.delivery_overview.actions')">
                {{ trans('pages.delivery_overview.actions') }}
            </ui5-table-column>
            <ui5-table-row v-for="(route, index) in routes" :key="route.id">
                <ui5-table-cell>{{ route.id }}</ui5-table-cell>
                <ui5-table-cell>{{ route.name }}</ui5-table-cell>
                <ui5-table-cell>{{ route.description }}</ui5-table-cell>
                <ui5-table-cell class="actions">
                    <span @click="navigateToEdit(route.id)">
                        <i class="fa fa-pencil"></i>
                    </span>
                    <span @click="navigateToDetail(route.id)">
                        <i class="fa fa-info-circle"></i>
                    </span>
                    <span @click="removeDeliveryRoute(route.id, index)">
                        <i class="fa fa-trash"></i>
                    </span>
                </ui5-table-cell>
            </ui5-table-row>
        </ui5-table>
    </div>
</template>
<style>
#deliveryoverviewpage .actions .fa {
    padding: 5px;
}
</style>
<script>
import deliveryRoutesApi from '../api/deliveryRoutes';
import {
    showConfirmDialog,
    showInfoMessage,
    showErrorMessage,
} from '../dialogs';
import localization from '../mixins/localization';

export default {
    mixins: [localization],
    data() {
        return {
            routes: [],
        };
    },
    methods: {
        removeDeliveryRoute(routeId, index) {
            showConfirmDialog({
                title: this.trans('pages.delivery_overview.delete_route.title'),
                content: this.trans('pages.delivery_overview.delete_route.confirmation'),
                confirm: () => {
                    deliveryRoutesApi
                        .deleteRoute(routeId)
                        .then(() => {
                            showInfoMessage(this.trans('pages.delivery_overview.delete_route.success'));
                            this.$delete(this.routes, index);
                        })
                        .catch(() => {
                            showErrorMessage(this.trans('pages.delivery_overview.delete_route.error'));
                        });
                },
                closeOnCancel: true,
                closeOnOk: true,
                confirmButton: this.trans('pages.delivery_overview.confirm'),
                cancelButton: this.trans('pages.delivery_overview.cancel'),
            });
        },
        navigateToEdit(routeId) {
            this.$router.push('/editdeliveryroute/' + routeId);
        },
        navigateToDetail(routeId) {
            this.$router.push('/deliveryroutesdetails/' + routeId);
        },
    },
    mounted() {
        deliveryRoutesApi.listRoutes().then((request) => {
            this.routes = request.data.data;
        });
    },
};
</script>
